import { IconWrapper } from '../runtime';
export default IconWrapper('designator', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M10 8.74982H5.75C4.09315 8.74982 2.75 10.093 2.75 11.7498V13.9498C2.75 14.1155 2.88431 14.2498 3.05 14.2498H9M10.75 3.74982C10.75 5.2686 9.51878 6.49982 8 6.49982C6.48122 6.49982 5.25 5.2686 5.25 3.74982C5.25 2.23103 6.48122 0.999817 8 0.999817C9.51878 0.999817 10.75 2.23103 10.75 3.74982Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M9.5 11.2913L11.5 13.2498L15 9.79126",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});